<!-- 器检党建 -->
<template>
  <div class="party-building-page">
    <div class="mytab"><div class="tag">党建动态</div></div>
    <div class="list-box">
      <news-list></news-list>
    </div>
  </div>
</template>
<script>
import newsList from '../../components/news/news-list.vue'
export default {
  name: '',
  props: [],
  components: { newsList },
  data() {
    return {}
  },
  watch: {},
  methods: {},
  mounted() {},
  created() {}
}
</script>

<style lang="scss" scope>
.party-building-page {
  width: 100%;
  .mytab {
    background: url(../../assets/images/img_8.webp) no-repeat;
    background-size: 100% 100%;
    .tag {
      background: url(../../assets/images/img_7.webp) no-repeat;
      background-size: 100% 100%;
    }
  }
  .list-box {
    margin-bottom: 8px;
    background-color: #fff;
  }
}
</style>
